import { render, staticRenderFns } from "./rescrutinyNoticeForm.vue?vue&type=template&id=54a47cb4&scoped=true&"
import script from "./rescrutinyNoticeForm.vue?vue&type=script&lang=js&"
export * from "./rescrutinyNoticeForm.vue?vue&type=script&lang=js&"
import style0 from "./rescrutinyNoticeForm.vue?vue&type=style&index=0&id=54a47cb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a47cb4",
  null
  
)

export default component.exports